export enum StatusAkceptacji {
  KopiaRobocza,
  NieZaakceptowano,
  PrzekazanoDoAkceptacji,
  Zaakceptowano,
}
